import { useContext } from 'react'
import { Grid, Typography, useMediaQuery } from '@mui/material'

import { withStyles } from '@material-ui/core/styles'
import styles from './franchiseDashboardStyles'

import { reducerContext } from '../../../../contextApi\'s/contextApi\'s'

import WebView from './WebView'
import MobileView from './MobileView'

const FranchiseDashboard = ({ classes }) => {
    const { dispatch } = useContext(reducerContext)

    const isSmallScreen = useMediaQuery('(max-width: 600px)')

    return (
        <Grid >
           { isSmallScreen ? (<MobileView dispatch={dispatch} />) : (<WebView dispatch={dispatch} />)} 
        </Grid>
    )
}

export default withStyles(styles)(FranchiseDashboard)